<template>
  <div class="page-content">
    <!-- 未加载出数据时显示骨架屏幕 -->
    <Skeleton v-if="detailLoading" />
    <div v-else>
      <!-- 顶部 -->
      <div class="product-top">
        <img
          class="product-img"
          :style="{width: windowInnerWidth}"
          :src="detail.productBanner||require('@/assets/images/login-bg.png')"
        >
      </div>
      <!-- 选项卡 -->
      <div class="tab-box">
        <div class="tab-select">
          <!-- <div
            :class="['tab-option', {select:tabIndex===1}]"
            @click="changeTab(1)"
          >
            <span class="tab-option-text">概览</span>
          </div> -->
          <div
            v-if="detail.versionList && detail.versionList.length"
            :class="['tab-option', {select:tabIndex===2}]"
            @click="changeTab(2)"
          >
            <span class="tab-option-text">版本和定价</span>
          </div>
        </div>
        <!-- <div
          v-if="tabIndex===1"
        >
          <DetailModel></DetailModel>
        </div> -->
        <div
          v-if="tabIndex===2"
        >
          <div
            class="card-box"
            :style="{'justify-content': cardBoxJust}"
          >
            <Card
              v-for="(item,index) in detail.versionList"
              :key="index"
              :card-data="item"
            />
          </div>
          <div class="ability-box">
            <table
              cellpadding="0"
              cellspacing="0"
              class="ability-table ability-table1"
            >
              <tr>
                <th class="ability-th empty-box"></th>
                <th
                  v-for="(item,index) in detail.versionList"
                  :key="index"
                  class="ability-th"
                  :style="{width:fixedWdith}"
                >
                  <div class="ability-version">
                    {{ item.versionName }}
                  </div>
                  <div class="ability-price">
                    <span>{{ item.salePrice }}</span>
                    <span class="ability-unit">元/{{ item.servicePeriod }}</span>
                  </div>
                </th>
              </tr>
            </table>
            <table
              v-for="(key,index) in Object.keys(ability)"
              :key="index"
              cellpadding="0"
              cellspacing="0"
              class="ability-table"
            >
              <tr>
                <th
                  :colspan="detail.versionList.length+1"
                  class="ability-th ability-name"
                >
                  {{ key }}
                </th>
              </tr>
              <tr
                v-for="(td,tdIndex) in ability[key]"
                :key="tdIndex"
                class="ability-tr"
                @mouseenter="productVersion.on.mouseenter(td)"
                @mouseleave="productVersion.on.mouseleave(td)"
              >
                <td class="ability-td">
                  <div style="font-weight: bold; font-size: 14px;">
                    {{ td.abilityName }}
                  </div>
                  <div style="white-space: normal; font-size: 12px;">
                    <div>{{ td.abilityRemark }}</div>
                  </div>
                </td>
                <td
                  v-for="(versionItem,versionIndex) in detail.versionList"
                  :key="versionIndex"
                  class="ability-td ability-td-center"
                  :style="{width:fixedWdith}"
                >
                  <span v-if="td.abilityName==='店铺数量'">
                    {{ versionItem.abilityListObj[td.abilityName]?versionItem.abilityListObj[td.abilityName].shopNum+'个店铺':'无店铺' }}
                  </span>
                  <Icon
                    v-else
                    type="ios-checkmark-circle"
                    size="24"
                    :color="versionItem.abilityList.find(ele=>ele.abilityName===td.abilityName)?'#19be6b':'#cccccc'"
                  />
                </td>
              <!-- <td class="ability-td ability-td-center">
                <Icon
                  size="24"
                  type="ios-checkmark-circle"
                  :color="td.specialAbility?'#19be6b':'#ccc'"
                />
              </td>
              <td class="ability-td ability-td-center">
                <Icon
                  size="24"
                  type="ios-checkmark-circle"
                  :color="td.seniorAbility?'#19be6b':'#ccc'"
                />
              </td> -->
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from './components/Skeleton';
import Card from './components/Card';
// import DetailModel from './components/detailModel';
export default {
  components: {
    Skeleton,
    Card,
    // DetailModel,
  },
  data(){
    return {
      detailLoading: true,
      productVersion: {
        on: {
          mouseenter: (item)=>{
            if (item.timer){
              clearTimeout(item.timer);
            }
            item.timer = setInterval(()=>{
              this.$set(item,'visible',true);
            },300);
            
          },
          mouseleave: (item)=>{
            if (item.timer){
              clearTimeout(item.timer);
            }
            this.$set(item,'visible',false);
          },
        },
      },
      detail: {

      },
      ability: {
        // abilityGroup: {
        //   abilityGroup: '',
        //   list: [],
        // },
      },
      tabIndex: 2,
      cardBoxJust: 'center',
      windowInnerWidth: `${window.innerWidth - this.getScrollbarWidth()}px`,
      scrollbarWidth: 0,
    };
  },
  computed: {
    fixedWdith(){
      const length = this?.detail?.versionList?.length??1;
      return `${((1160 - 250)/length).toFixed(3) }px`;
    },
  },
  watch: {
    $route: {
      handler() {
        this.getDetail();
      },
      deep: true,
    },
  },
  created(){
    this.getDetail();
    
  },
  mounted(){
    window.addEventListener('resize', this.onWindowResize);
    this.scrollbarWidth = this.getScrollbarWidth();
    this.windowInnerWidth = `${window.innerWidth - this.scrollbarWidth}px`;
  },
  beforeDestroy() {
    // 事件注销
    window.onresize = null;
  },
  methods: {
    // 获取详情
    getDetail() {
      const {corpCode} = this.$store.state.user.userInfo;
      const url = '/paycenter-charge/api/facade/product/view';
      const params = {
        productCode: this.$route.query.productCode,
        corpCode,
      };
      this.detailLoading = true;
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.detailLoading = false;
          this.detail = res.data; 
          const {versionList} = res.data;
         
          if (versionList && versionList.length){
            switch (versionList.length) {
              case 1:
                this.cardBoxJust = 'center';
                break;
              case 2:
                this.cardBoxJust = 'space-around';
                break;
              default:
                this.cardBoxJust = 'space-between';
                break;
            }
            versionList.forEach(item=>{
              const {abilityList} = item;
              const abilityListObj = {};
              abilityList.forEach(ele=>{
                abilityListObj[ele.abilityName] = ele;
              });
              item.abilityListObj = abilityListObj;
            });
          }
          // 能力分组
          this.formatAbility();

        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 能力分组
    formatAbility(){
      const ability = {};
      const {allAbility} = this.detail;
      if (allAbility && allAbility.length){
        allAbility.forEach(ele=>{
          if (ability[ele.abilityGroup]){
            ability[ele.abilityGroup].push(ele);
          } else {
            ability[ele.abilityGroup] = [ele];
          }
        });
      }
     
      this.ability = ability;
    },
    goOrder(versionName){
      const {corpList,token} = this.$store.state.user.userInfo;
      if (token && (!corpList||!corpList.length)){
        // 弹出去认证弹框
        this.$root.$emit('show-auth-modal');
        return;
      }
      const {productCode} = this.$route.query;
      this.$router.push({
        path: '/standardProduct/order/index',
        query: {
          productCode,
          // corpCode,
          // corpName,
          versionName,
          // exchange: false,
        },
      });
    },
    // 去兑换
    goExchange(){
      const {corpList,token} = this.$store.state.user.userInfo;
      if (token && (!corpList||!corpList.length)){
        // 弹出去认证弹框
        this.$root.$emit('show-auth-modal');
        return;
      }
      const {productCode} = this.$route.query;
      
      const {href} = this.$router.resolve({
        path: '/standardProduct/exchange/index',
        query: {
          productCode,
          // corpCode,
          // corpName,
          from: 'productVersion',
        },
      });
      // window.open(href,'_blank');
      window.location.href = href;
    },
    changeTab(tabIndex){
      this.tabIndex = tabIndex;
    },
    onWindowResize(){
      this.windowInnerWidth = `${window.innerWidth - this.scrollbarWidth}px`;
    },
    // 获取滚动条宽度
    getScrollbarWidth() {
      // 通过给元素强制增加滚动条，比较增加前后的宽度
      const oP = document.createElement('p');
      const styles = {
        width: '100px',
        height: '100px',
      };
      for (const i in styles) {
        oP.style[i] = styles[i];
      }
      document.body.appendChild(oP);
      const clientWidth1 = oP.clientWidth;
      oP.style.overflowY = 'scroll';
      const clientWidth2 = oP.clientWidth;
      const scrollbarWidth = clientWidth1 - clientWidth2;
      oP.remove();
      return scrollbarWidth;
    },
  },
};
</script>
<style lang="less" scoped>
@tableBorderColor: #efefef;
.product-top {
  .product-img {
    width: 100%;
    height: 288px;
    position: absolute;
    left: 0;
    top: 68px;
  }
  .product-top-right {
    padding-left: 20px;
  }
  .product-name {
    font-size: 18px;
    color: #333;
    // padding-top: 20px;
  }
  .product-intro {
    font-size: 14px;
    color: #999;
    padding: 30px 0;
  }
  .order-btn {
    // margin-top: 30px;
    width: 200px;
    // border-color: #bcbcbc;
    // height: 30px;
    // line-height: 30px;
    border-radius: 0;
  }
  .exchange-box {
    // margin-top: 10px;
    position: absolute;
    right: 30px;
    bottom: 10px;
    font-size: 12px;
    .exchange-text {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
    .exchange-btn {
      vertical-align: middle;
      // margin-left: 5px;
      cursor: pointer;
      color: #409eff;
      padding: 0;
    }
  }
}
.tab-box {
  background-color: #fff;
  padding: 20px 0;
  padding-top: 308px;
  .tab-select {
    display: flex;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 20px;
    .tab-option {
      margin-right: 30px;
      margin-bottom: -1px;
      .tab-option-text {
        padding: 5px 20px;
        display: inline-block;
        // font-weight: bold;
        font-size: 18px;
        font-weight: bold;
      }
      &.select {
        .tab-option-text {
          color: #5e7ce0;
          border-bottom: 2px solid #5e7ce0;
        }
      }
    }
  }
  /deep/.ivu-tabs-bar {
    border-bottom: 1px solid #e8eaec;
  }
  .productDesc {
    min-height: 300px;
    // overflow-y: auto;
  }
}
.card-box {
  overflow: hidden;
  margin-bottom: 106px;
  padding: 20px;
  display: flex;
  justify-content: center;
  .card-item {
    box-sizing: border-box;
    float: left;
    // width: 30%;
    margin: 0 1.5%;
    max-width: 400;
    background-color: #fff;
    box-shadow: 0 0 10px 1px #e7e7e7;
    padding: 20px;
    text-align: center;
    border-radius: 5px;
  }
  .card-name {
    font-size: 18px;
    color: #333;
    // font-weight: bold;
  }
  .card-content {
    font-size: 14px;
    color: #999;
    padding: 10px 10px 0;
    min-height: 70px;
  }
  .price {
    color: #f93434;
    font-size: 30px;
    // padding: 0 2px;
  }
  .price-icon {
    font-size: 13px;
    color: #f93434;
  }
  .price-unit {
    font-size: 13px;
    color: #999;
  }
  .price-old {
    font-size: 14px;
    color: #999;
    text-decoration: line-through;
  }
}
.ability-box {
  background-color: #fff;
  // border: 1px solid #f2f2f2;
  padding: 0 20px;
}
.ability-table {
  width: 100%;
  // border-left: 1px solid #f2f2f2;
  border-right: 1px solid @tableBorderColor;
  // border-top: 1px solid #f2f2f2;
  &1 {
    // border-top: 1px solid @tableBorderColor;
    .ability-th{
      border-top: 1px solid @tableBorderColor;
    }
    .empty-box.ability-th{
      border-top:0;
      border-left: 0;
    }
  }
  /deep/ .ivu-tooltip-inner {
    background-color: #fff;
    color: #333;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  }
  /deep/ .ivu-tooltip-popper[x-placement^="right"] .ivu-tooltip-arrow {
    // border-right-color: #fff;
    border: 4px solid #fff;
    transform: rotate(-135deg);
    box-shadow: 1px -1px 4px -1px rgba(0, 0, 0, 0.3);
  }
  .ability-tr {
    // height: 95px;
    padding: 20px;
    box-sizing: border-box;
    &:hover {
      background-color: #f7f7f7;
    }
  }
  .ability-version {
    font-size: 18px;
    font-weight: bold;
  }
  .ability-price{
    font-size: 22px;
    color: #333;
    font-weight: normal;
    .ability-unit{
      font-size: 14px;
      color: #666;
    }
  }
  .ability-th {
    padding: 10px 5px;
    border-left: 1px solid @tableBorderColor;
    border-bottom: 1px solid @tableBorderColor;
    &1 {
      // width: 150px;
      // border-left: 0;
      width: 20%;
    }
  }
  .ability-name {
    text-align: left;
    background: #f6f6f6;
    padding-left: 20px;
    height: 46px;
    box-sizing: border-box;
  }
  .ability-td {
    padding: 20px;
    border-bottom: 1px solid @tableBorderColor;
    border-left: 1px solid #e5e5e5;
    &1 {
      // width: 150px;
      // border-left: 0;
      width: 20%;
    }
    &-center {
      text-align: center;
    }
  }
}
</style>